import React from "react";
import { Box } from "@mui/material";

const PAYMENT_LOGO_BOX_WIDTH = 72;
const PAYMENT_LOGO_BOX_HEIGHT = 36;

export function PaymentMethodLogoBox({ urlLogo, alt = "", muted = false }) {
  if (!urlLogo) return null;

  return (
    <Box
      sx={{
        width: PAYMENT_LOGO_BOX_WIDTH,
        height: PAYMENT_LOGO_BOX_HEIGHT,
        borderRadius: "6px",
        border: muted ? "1px solid rgba(0, 0, 0, 0.28)" : "1px solid rgba(0, 0, 0, 0.85)",
        backgroundColor: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        flexShrink: 0,
        px: 0.75,
        py: 0.25,
        boxSizing: "border-box",
      }}
    >
      <Box
        component="img"
        src={urlLogo}
        alt={alt}
        sx={{
          display: "block",
          maxWidth: "100%",
          maxHeight: "100%",
          width: "auto",
          height: "auto",
          objectFit: "contain",
          filter: muted ? "grayscale(100%)" : "none",
          opacity: muted ? 0.72 : 1,
        }}
      />
    </Box>
  );
}
